import { forwardRef, type SVGProps } from 'react';

export const PersonErrorIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function PersonErrorIcon(props, ref) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8C8 9.06087 8.42143 10.0783 9.17157 10.8284C9.92172 11.5786 10.9391 12 12 12C13.0609 12 14.0783 11.5786 14.8284 10.8284C15.5786 10.0783 16 9.06087 16 8C16 6.93913 15.5786 5.92172 14.8284 5.17157ZM13.4686 14.0672C12.9925 14.0231 12.5017 14 12 14C7.58 14 4 15.79 4 18V20H12.3414C12.1203 19.3744 12 18.7013 12 18C12 16.4955 12.5538 15.1203 13.4686 14.0672Z"
        fill="#CC2C29"
        fillRule="evenodd"
      />
      <path
        d="M18 13C20.765 13 23 15.235 23 18C23 20.765 20.765 23 18 23C15.235 23 13 20.765 13 18C13 15.235 15.235 13 18 13ZM19.795 15.5L18 17.295L16.205 15.5L15.5 16.205L17.295 18L15.5 19.795L16.205 20.5L18 18.705L19.795 20.5L20.5 19.795L18.705 18L20.5 16.205L19.795 15.5Z"
        fill="#CC2C29"
      />
    </svg>
  );
});
